export const generalError = (type, error) => {
  return {type, error};
};
